import { getPaddingString, toRGBA } from "../parser/utils";

export default ({ data, id }) => {
  const { html, backgroundColor, contentID } = data;
  return `
    <div id="${contentID || id}" style="${getPaddingString(data)};background-color: ${toRGBA(backgroundColor)}">
      ${html}
    </div>
  `;
};
